import type { strokeDashTypes } from 'react-financial-charts';
import { defaultShapePropertyValues } from './defaultShapePropertyValues';
import { ShapeType } from '@/types/commontypes';

export const setDirection = (
  props: { arrow?: [string, string] } | null | undefined,
): 'left' | 'right' | 'both' | 'none' => {
  const left = props?.arrow?.[0] === 'arrow';
  const right = props?.arrow?.[1] === 'arrow';
  if (left && right) return 'both';
  if (left) return 'left';
  if (right) return 'right';
  return 'none';
};

export const getLineOptionAppearance = (
  lineProps: { strokeStyle?: string; strokeDasharray?: strokeDashTypes; strokeWidth?: number | string } = {},
) => {
  const lineDefaults = defaultShapePropertyValues[ShapeType.TREND_LINE]?.line;
  return {
    strokeStyle: lineProps?.strokeStyle || lineDefaults?.strokeStyle || '#2962ff',
    strokeDasharray: lineProps?.strokeDasharray || lineDefaults?.strokeDasharray || 'Solid',
    strokeWidth: Number(lineProps?.strokeWidth) || lineDefaults?.strokeWidth || 2,
  };
};
